const WorkerManager = {

    // track calls to worker and their callback functions
    callbackId: 0,
    callbacks: {},

    newWorker: function() {
        let worker = new Worker(new URL('./worker.js', import.meta.url));
        worker.onmessage = WorkerManager.onWorkerMessage
        return worker;
    },

    postMessage: function(worker, action, options, callback) {
        const id = WorkerManager.callbackId++;

        // save callback function
        WorkerManager.callbacks[id] = callback;

        worker.postMessage({
            id: id,
            action,
            options,
        })
    },

    onWorkerMessage: function (e) {
        const {action, id, status, result} = e.data;
        if (!WorkerManager.callbacks[id]) {
            console.warn("No callback attached for worker call: ", {action, id});
            return;
        }
        WorkerManager.callbacks[id](status, result);
        WorkerManager.callbacks[id] = null;
    }
}

export default WorkerManager;